// No-op storage implementation
class NoOpStorage {
  getItem() {
    return null;
  }

  setItem() {
    // no-op
  }

  removeItem() {
    // no-op
  }

  clear() {
    // no-op
  }

  key() {
    return null;
  }

  get length() {
    return 0;
  }
}

// Test if storage is available and working
function isStorageAvailable(type: "localStorage" | "sessionStorage") {
  try {
    const storage = window[type];
    const test = "__storage_test__";
    storage.setItem(test, test);
    storage.removeItem(test);
    return true;
  } catch {
    return false;
  }
}

// Monkeypatch localStorage
if (!isStorageAvailable("localStorage")) {
  Object.defineProperty(window, "localStorage", {
    value: new NoOpStorage(),
    writable: false,
    configurable: true,
  });
}

// Monkeypatch sessionStorage
if (!isStorageAvailable("sessionStorage")) {
  Object.defineProperty(window, "sessionStorage", {
    value: new NoOpStorage(),
    writable: false,
    configurable: true,
  });
}
